import React from 'react'
import LoginLayout from 'components/LoginLayout'
import appleLogo from 'assets/logo_apple_store.png'
import googleLogo from 'assets/logo_google_store.png'
import styles from './styles.less'

export default function MobilePage() {
  return (
    <LoginLayout>
      <div className={styles.container}>
        <p className={styles.body}>
          Use Groove on the go through the native mobile apps. Available for
          both Android and iOS, they offer the best experience with all the main
          features of the web app.
          <br />
          <br />
          To download the app for your platform, visit the relevant store:
        </p>
        <div>
          <a
            href="https://apps.apple.com/app/groove-help-desk/id1509476768"
            rel="noopener noreferrer"
            target="_blank"
            className={styles.link}
          >
            <img
              src={appleLogo}
              alt="Download on the App Store"
              className={styles.img}
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.groovehq.app"
            rel="noopener noreferrer"
            target="_blank"
            className={styles.link}
          >
            <img
              src={googleLogo}
              alt="Get it on Google Play"
              className={styles.img}
            />
          </a>
        </div>
      </div>
    </LoginLayout>
  )
}
